<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <h1 v-if="!isAuthenticated">Not Authenticated</h1>
    <UserProfile v-if="isAuthenticated" msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import UserProfile from "@/components/UserProfile.vue";

export default {
    name: "home",
    components: {
    },
    computed: {
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated;
        }
    }
};
</script>
